import { render } from "./LatestPosts.vue?vue&type=template&id=f51e50c4&scoped=true"
import script from "./LatestPosts.vue?vue&type=script&lang=js"
export * from "./LatestPosts.vue?vue&type=script&lang=js"

import "./LatestPosts.vue?vue&type=style&index=0&id=f51e50c4&scoped=true&lang=css"

import exportComponent from "D:\\lawstudio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f51e50c4"]])

export default __exports__